import * as React from 'react';
import { AutoComplete, Space } from 'antd';
import { FI18n, FUtil } from '@freelog/tools-lib';
import FComponentsLib from '@freelog/components-lib';
import FTooltip from '@/components/FTooltip';
import styles from './index.less';
import type { SelectedCache, SearchResult } from './types';

interface CustomInputModeProps {
  disabled: boolean;
  width: number;
  onlySelect: boolean;
  selectedCache: SelectedCache;
  autoCompleteInput: string;
  autoCompleteInputIsNew: boolean;
  autoCompleteOptions: SearchResult[];
  autoCompleteOptionsOther: SearchResult[];
  onInputChange: (value: string) => void;
  onSelect: (value: string, data: SearchResult) => void;
  onSelectNew: () => void;
  onBlur: () => void;
}

function CustomInputMode({
  disabled,
  width,
  onlySelect,
  selectedCache,
  autoCompleteInput,
  autoCompleteInputIsNew,
  autoCompleteOptions,
  autoCompleteOptionsOther,
  onInputChange,
  onSelect,
  onSelectNew,
  onBlur,
}: CustomInputModeProps) {
  const startStr = [...selectedCache.labels, ''].join('/');

  const buildOptionItems = (items: SearchResult[]) =>
    items.map((aco) => ({
      value: aco.value,
      label: (
        <div className={styles.autoCompleteOption}>
          <FTooltip
            styles={{ body: { width: 'fit-content' } }}
            title={aco.labels.join('/')}
            mouseEnterDelay={0.5}
          >
            <span>{aco.labels.join('/')}</span>
          </FTooltip>
          <FComponentsLib.FContentText
            text={FI18n.i18nNext.t('createresource_selectresourcetype_input_resourceqty', {
              ResourceQty: aco.count,
            })}
            type="additional2"
          />
        </div>
      ),
      data: aco,
    }));

  const newTypeOption =
    autoCompleteInputIsNew && !onlySelect
      ? [
          {
            value: '#new',
            label: (
              <div className={styles.autoCompleteOption}>
                <FTooltip
                  styles={{ body: { width: 'fit-content' } }}
                  title={autoCompleteInput}
                  mouseEnterDelay={0.5}
                >
                  <span>{autoCompleteInput}</span>
                </FTooltip>
                <FComponentsLib.FTextBtn>
                  {FI18n.i18nNext.tAuto('createresource_selectresourcetype_btn_addthis')}
                </FComponentsLib.FTextBtn>
              </div>
            ),
            data: {
              value: '#new',
              label: '',
              values: [] as string[],
              labels: autoCompleteInput.split('/'),
              count: 0,
            },
          },
        ]
      : [];

  return (
    <div style={{ display: 'block' }}>
      <AutoComplete
        dropdownClassName={styles.autoCompleteDropdown}
        dropdownStyle={{ padding: 0, width }}
        disabled={disabled}
        autoFocus
        defaultOpen
        options={[
          ...newTypeOption,
          ...buildOptionItems(autoCompleteOptions),
          ...buildOptionItems(autoCompleteOptionsOther),
        ]}
        style={{ width, height: 38 }}
        value={autoCompleteInput}
        className={styles.AutoComplete}
        onChange={(value: string) => {
          if (!value || !value.startsWith(startStr)) return;
          if (value.length <= startStr.length + 40) {
            onInputChange(value);
          }
        }}
        onSelect={(value: any, op: any) => {
          const data: SearchResult = op.data;
          if (value === '#new') {
            onSelectNew();
          } else {
            onSelect(value, data);
          }
        }}
        onBlur={() => {
          setTimeout(onBlur, 100);
        }}
      />
      {!onlySelect && (
        <>
          <div style={{ height: 30 }} />
          <Space style={{ display: 'flex' }} size={5} direction="vertical">
            <FComponentsLib.FContentText
              text={'目前仅支持中文、英文、数字，及符号"-"、"&"、"."、","'}
              type="additional2"
            />
            <FComponentsLib.FContentText text={'英文区分大小写'} type="additional2" />
            <FComponentsLib.FContentText text={'长度必须在1-40个字符之间'} type="additional2" />
          </Space>
        </>
      )}
    </div>
  );
}

export default CustomInputMode;
